import axiosClient from "../../network";

export default class paymentService {
  static getTransactions(params) {
    return axiosClient
      .get("/user/transactions", {
        params,
        cache: {
          maxAge: 0
        }
      })
      .then(({ data }) => {
        return data;
      })
      .catch((error) => {
        if (error.data) {
          return { error: error.data };
        }
        return {
          error
        };
      });
  }

  static getAllCurrency(params = {}) {
    return axiosClient
      .get("/payment/getAllCurrency", {
        params
      })
      .then(([data]) => {
        return data;
      })
      .catch((error) => {
        if (error.data) {
          throw new Error(error.data.message);
        }
        throw new Error(error.message);
      });
  }

  static getCoins() {
    return axiosClient
      .get("/payment/getCoins")
      .then(({ data }) => {
        return data;
      })
      .catch((error) => {
        if (error.data) {
          throw new Error(error.data.message);
        }
        throw new Error(error.message);
      });
  }

  static generateAddress(params) {
    return axiosClient
      .get("/payment/generateAddress", {
        params
      })
      .then(({ data }) => {
        return data;
      })
      .catch((error) => {
        if (error.data) {
          throw new Error(error.data.message);
        }
        throw new Error(error.message);
      });
  }

  static getConvertedBalance(params) {
    return axiosClient
      .get("/payment/getConvertedBalance", {
        params
      })
      .then(({ data }) => {
        return data;
      })
      .catch((error) => {
        if (error.data) {
          throw new Error(error.data.message);
        }
        throw new Error(error.message);
      });
  }

  static withdrawalRequest(payload) {
    return axiosClient
      .post("/payment/withdrawalRequest", payload)
      .then(({ data }) => {
        return data;
      })
      .catch((error) => {
        if (error.data) {
          throw new Error(error.data.message);
        }
        throw new Error(error.message);
      });
  }
}
